module.exports = __webpack_public_path__ + "img/703-616025.png";